var exports = {
  "Er": "ChannelOverviewTab.module__regionOption___bFNHYT",
  "pG": "ChannelOverviewTab.module__regionEmoji___bFNHYT",
  "Kj": "ChannelOverviewTab.module__regionEmojiText___bFNHYT",
  "c5": "ChannelOverviewTab.module__topicInput___bFNHYT",
  "Z8": "ChannelOverviewTab.module__emojiButton___bFNHYT",
  "IJ": "ChannelOverviewTab.module__emojiButtonInactive___bFNHYT",
  "Dg": "ChannelOverviewTab.module__emojiButtonActive___bFNHYT",
  "p9": "ChannelOverviewTab.module__sectionWrapper___bFNHYT",
  "h3": "ChannelOverviewTab.module__settingsGroup___bFNHYT",
  "hB": "ChannelOverviewTab.module__settingsControlRow___bFNHYT",
  "S8": "ChannelOverviewTab.module__settingsControlRowStacked___bFNHYT",
  "Y4": "ChannelOverviewTab.module__settingsControlText___bFNHYT",
  "vK": "ChannelOverviewTab.module__settingsControlTitleRow___bFNHYT",
  "H1": "ChannelOverviewTab.module__settingsControlLabel___bFNHYT",
  "H7": "ChannelOverviewTab.module__settingsControlDescription___bFNHYT",
  "yN": "ChannelOverviewTab.module__settingsSliderControl___bFNHYT",
};

module.exports = exports;
